import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { Appointment } from './Appointment.entity';
import { Article } from './Article.entity';
import { Calculation } from './Calculation.entity';
import { CallMemo } from './CallMemo.entity';
import { CheckList } from './CheckList.entity';
import { CommentEvent } from './CommentEvent.entity';
import { Contract } from './Contract.entity';
import { Customer } from './Customer.entity';
import { DeliveryNote } from './DeliveryNote.entity';
import { Demand } from './Demand.entity';
import { Document } from './Document.entity';
import { EMail } from './EMail.entity';
import { InboundDeliveryNote } from './InboundDeliveryNote.entity';
import { InboundInvoice } from './InboundInvoice.entity';
import { Invoice } from './Invoice.entity';
import { Letter } from './Letter.entity';
import { Note } from './Note.entity';
import { Offer } from './Offer.entity';
import { Order } from './Order.entity';
import { ProductionContract } from './ProductionContract.entity';
import { Project } from './Project.entity';
import { SalesOpportunities } from './SalesOpportunities.entity';
import { Supplier } from './Supplier.entity';
import { Task } from './Task.entity';
import { Ticket } from './Ticket.entity';
import { VisitationReport } from './VisitationReport.entity';

export type MentionUnion<T extends EMode = EMode.entity> =
  T extends EMode.entity
    ?
        | CommentEvent<T>
        | Ticket<T>
        | Task<T>
        | Appointment<T>
        | CheckList<T>
        | Note<T>
        | SalesOpportunities<T>
        | CallMemo<T>
        | VisitationReport<T>
        | Document<T>
        | EMail<T>
        | Letter<T>
        | Offer<T>
        | InboundDeliveryNote<T>
        | ProductionContract<T>
        | Contract<T>
        | InboundInvoice<T>
        | Invoice<T>
        | Demand<T>
        | Calculation<T>
        | Order<T>
        | DeliveryNote<T>
        | Customer<T>
        | Supplier<T>
        | Project<T>
        | Article<T>
    : {
        /** Alias: CommentEvent */
        commentEvent?: CommentEvent<T>;
        /** Alias: Ticket */
        ticket?: Ticket<T>;
        /** Alias: Aufgabe */
        task?: Task<T>;
        /** Alias: Termin */
        appointment?: Appointment<T>;
        /** Alias: Checkliste */
        checkList?: CheckList<T>;
        /** Alias: Notiz */
        note?: Note<T>;
        /** Alias: Verkaufschance */
        salesOpportunities?: SalesOpportunities<T>;
        /** Alias: Telefonat */
        callMemo?: CallMemo<T>;
        /** Alias: Besuchsbericht */
        visitationReport?: VisitationReport<T>;
        /** Alias: Dokument */
        document?: Document<T>;
        /** Alias: EMail */
        eMail?: EMail<T>;
        /** Alias: Brief */
        letter?: Letter<T>;
        /** Alias: Angebot */
        offer?: Offer<T>;
        /** Alias: Eingangslieferschein */
        inboundDeliveryNote?: InboundDeliveryNote<T>;
        /** Alias: Produktionsauftrag */
        productionContract?: ProductionContract<T>;
        /** Alias: Auftrag */
        contract?: Contract<T>;
        /** Alias: Eingangsrechnung */
        inboundInvoice?: InboundInvoice<T>;
        /** Alias: Rechnung */
        invoice?: Invoice<T>;
        /** Alias: Bedarfsanforderung */
        demand?: Demand<T>;
        /** Alias: Kalkulation */
        calculation?: Calculation<T>;
        /** Alias: Bestellung */
        order?: Order<T>;
        /** Alias: Lieferschein */
        deliveryNote?: DeliveryNote<T>;
        /** Alias: Kunde */
        customer?: Customer<T>;
        /** Alias: Lieferant */
        supplier?: Supplier<T>;
        /** Alias: Projekt */
        project?: Project<T>;
        /** Alias: Artikel */
        article?: Article<T>;
      };

const fields: FieldDefinitions<MentionUnion<EMode.query>> = {
  commentEvent: {
    alias: 'commentEvent',
    entity: Entities.commentEvent,
  },
  ticket: {
    alias: 'ticket',
    entity: Entities.ticket,
  },
  task: {
    alias: 'task',
    entity: Entities.task,
  },
  appointment: {
    alias: 'appointment',
    entity: Entities.appointment,
  },
  checkList: {
    alias: 'checkList',
    entity: Entities.checkList,
  },
  note: {
    alias: 'note',
    entity: Entities.note,
  },
  salesOpportunities: {
    alias: 'salesOpportunities',
    entity: Entities.salesOpportunities,
  },
  callMemo: {
    alias: 'callMemo',
    entity: Entities.callMemo,
  },
  visitationReport: {
    alias: 'visitationReport',
    entity: Entities.visitationReport,
  },
  document: {
    alias: 'document',
    entity: Entities.document,
  },
  eMail: {
    alias: 'eMail',
    entity: Entities.eMail,
  },
  letter: {
    alias: 'letter',
    entity: Entities.letter,
  },
  offer: {
    alias: 'offer',
    entity: Entities.offer,
  },
  inboundDeliveryNote: {
    alias: 'inboundDeliveryNote',
    entity: Entities.inboundDeliveryNote,
  },
  productionContract: {
    alias: 'productionContract',
    entity: Entities.productionContract,
  },
  contract: {
    alias: 'contract',
    entity: Entities.contract,
  },
  inboundInvoice: {
    alias: 'inboundInvoice',
    entity: Entities.inboundInvoice,
  },
  invoice: {
    alias: 'invoice',
    entity: Entities.invoice,
  },
  demand: {
    alias: 'demand',
    entity: Entities.demand,
  },
  calculation: {
    alias: 'calculation',
    entity: Entities.calculation,
  },
  order: {
    alias: 'order',
    entity: Entities.order,
  },
  deliveryNote: {
    alias: 'deliveryNote',
    entity: Entities.deliveryNote,
  },
  customer: {
    alias: 'customer',
    entity: Entities.customer,
  },
  supplier: {
    alias: 'supplier',
    entity: Entities.supplier,
  },
  project: {
    alias: 'project',
    entity: Entities.project,
  },
  article: {
    alias: 'article',
    entity: Entities.article,
  },
};

export const mentionUnionEntityDefinition: EntitiyDefinition<
  MentionUnion<EMode.query>
> = {
  kind: 'union',
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'MentionUnion',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
